export default "__VITE_ASSET__CW4tnx0X__"